// wa.me only accepts digits — no leading +, spaces, or separators.
export const SUPPORT_WHATSAPP_NUMBER = '918626097288';

const WHATSAPP_CLICK_TO_CHAT_BASE = 'https://wa.me';

// Support reads these messages as they arrive, so the product name is fixed copy
// rather than APP_NAME or a translated string.
export function buildSupportWhatsAppUrl(email?: string | null): string {
  const trimmedEmail = email?.trim();
  const message = trimmedEmail
    ? `Hi, I am using Proposal.biz with my email address ${trimmedEmail}, and I would like to connect with you.`
    : 'Hi, I am using Proposal.biz and I would like to connect with you.';

  return `${WHATSAPP_CLICK_TO_CHAT_BASE}/${SUPPORT_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
